<template>
  <v-container class="py-8">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-row justify="center">
      <v-col cols="12" md="8" lg="6" xl="5">
        <v-card class="elevation-6 rounded-xl overflow-hidden setting-card">
          <div class="card-header">
            <v-icon large color="white" class="mr-4">mdi-calendar-clock</v-icon>
            <div>
              <h2 class="white--text mb-1 font-weight-bold" style="font-family: 'Inter', sans-serif;">Attendance Automation</h2>
              <span class="white--text text-subtitle-2 opacity-80" style="font-family: 'Inter', sans-serif; font-weight: 300;">Manage automated schedulers and notifications</span>
            </div>
          </div>
          
          <v-card-text class="pa-4">
            <v-hover v-slot="{ hover }">
              <div 
                class="setting-item transition-swing rounded-lg pa-4 d-flex align-center justify-space-between"
                :class="hover ? 'elevation-3 bg-hover' : 'elevation-0'"
              >
                <div class="d-flex align-start">
                  <v-avatar color="#e6f0eb" size="48" class="mr-4 mt-1">
                    <v-icon color="#005f32" size="24">mdi-email-fast-outline</v-icon>
                  </v-avatar>
                  <div>
                    <h3 class="text-subtitle-1 mb-1 text--primary font-weight-bold" style="color: #2c3e50; font-family: 'Inter', sans-serif;">Unmarked Attendance Email Reminder</h3>
                    <p class="text-caption grey--text text--darken-1 mb-0" style="max-width: 500px; line-height: 1.4;">
                      Automatically send an email reminder to employees who have not marked their attendance for the day. Runs daily.
                    </p>
                  </div>
                </div>
                <div class="d-flex flex-column align-center pl-4 border-left">
                  <v-switch
                    v-model="unmarkedAttendanceEmailEnabled"
                    color="#005f32"
                    inset
                    hide-details
                    class="ma-0 pa-0 custom-switch"
                    @change="toggleUnmarkedAttendanceEmail"
                  ></v-switch>
                  <span class="text-caption mt-2 font-weight-medium" :style="{ color: unmarkedAttendanceEmailEnabled ? '#005f32' : '#9e9e9e' }">
                    {{ unmarkedAttendanceEmailEnabled ? 'Active' : 'Disabled' }}
                  </span>
                </div>
              </div>
            </v-hover>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";

export default {
  name: "AttendanceSettings",
  components: {
    VueElementLoading,
  },
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      msg: "",
      unmarkedAttendanceEmailEnabled: true,
    };
  },
  mounted() {
    this.fetchUnmarkedAttendanceEmailStatus();
  },
  methods: {
    fetchUnmarkedAttendanceEmailStatus() {
      this.appLoading = true;
      axios({
        url: "/organisation/settings/unmarkedAttendanceEmailScheduler/status",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
      .then((response) => {
        this.appLoading = false;
        if (response.data && response.data.status) {
          this.unmarkedAttendanceEmailEnabled = response.data.isEnabled;
        }
      })
      .catch((err) => {
        this.appLoading = false;
        console.log(err);
      });
    },
    toggleUnmarkedAttendanceEmail() {
      this.appLoading = true;
      axios({
        url: "/organisation/settings/unmarkedAttendanceEmailScheduler/toggle",
        method: "POST",
        data: { isEnabled: this.unmarkedAttendanceEmailEnabled },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
      .then((response) => {
        this.appLoading = false;
        if (response.data && response.data.status) {
          this.showsnackbar = true;
          this.msg = response.data.msg;
        }
      })
      .catch((err) => {
        this.appLoading = false;
        this.msg = "Failed to update setting";
        this.showsnackbar = true;
        console.log(err);
      });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700&display=swap');

.setting-card {
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.card-header {
  background: linear-gradient(135deg, #005f32 0%, #00a656 100%);
  padding: 20px 24px;
  display: flex;
  align-items: center;
}
.opacity-80 {
  opacity: 0.85;
}
.setting-item {
  border: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #f8fcf9;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.bg-hover {
  background-color: #ffffff;
  border-color: rgba(0, 95, 50, 0.15);
  transform: translateY(-3px);
}
.border-left {
  border-left: 1px solid rgba(0, 0, 0, 0.08);
}
.custom-switch ::v-deep .v-input--selection-controls__ripple {
  display: none;
}
</style>
